import React, { useEffect, useRef, useState } from "react";
import { Box, Typography } from "@mui/material";
import axios from "axios";
import useSharedLocation from "../../hooks/useSharedLocation";
import { MARKET_PRICES_ENDPOINT } from "../../globals/endpoints";

const TickerTape = () => {
  const [animationDuration, setAnimationDuration] = useState(30);
  const [marketPrices, setMarketPrices] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const containerRef = useRef(null);
  const contentRef = useRef(null);

  const { location } = useSharedLocation();

  const fetchInitialData = async (district, fallback = false, page = 1) => {
    const today = new Date();
    const options = { day: "2-digit", month: "short", year: "numeric" };
    const date = today.toLocaleDateString("en-GB", options);

    const encodedDistrict = encodeURIComponent(district);
    const encodedDate = date.replace(/ /g, "%20");

    const url = `${MARKET_PRICES_ENDPOINT}initial-data?date=${encodedDate}&district=${encodedDistrict}&limit=10&page=${page}`;

    try {
      const response = await axios.get(url, {
        headers: {
          accept: "application/xml",
        },
      });
      // Check if data is empty and fallback is false
      if (response.data.data.length === 0 && !fallback) {
        console.warn(`No data found for ${district}, falling back to Mumbai`);
        await fetchInitialData("Mumbai", true);
      } else {
        setMarketPrices(response.data.data);
        setIsLoading(false);
      }
    } catch (err) {
      console.error("Failed to fetch initial data", err);
      setError("Failed to fetch market prices");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (location?.district) {
      fetchInitialData(location.district);
    }
  }, [location]);

  useEffect(() => {
    if (containerRef.current && contentRef.current) {
      const containerWidth = containerRef.current.offsetWidth;
      const contentWidth = contentRef.current.offsetWidth;
      const duration = (contentWidth / containerWidth) * 3;
      setAnimationDuration(duration);
    }
  }, [marketPrices]);

  if (isLoading || error || marketPrices.length === 0) {
    return null;
  }

  const renderContent = () => {
    return (
      <Box
        ref={contentRef}
        sx={{
          display: "inline-flex",
          whiteSpace: "nowrap",
          animation: `scroll ${animationDuration}s linear infinite`,
          "@keyframes scroll": {
            "0%": { transform: "translateX(0)" },
            "100%": { transform: "translateX(-50%)" },
          },
        }}
      >
        {[...marketPrices, ...marketPrices].map((item, index) => (
          <Typography
            key={index}
            sx={{
              px: 2,
              display: "inline-block",
            }}
          >
            <span style={{ fontWeight: "bold" }}>{item.commodity} :</span>
            <span style={{ color: "#4CAF50", marginLeft: "10px" }}>
              ₹{parseFloat(item.modal_price).toFixed(2)}
            </span>
          </Typography>
        ))}
      </Box>
    );
  };

  return (
    <Box
      ref={containerRef}
      sx={{
        width: "100%",
        overflow: "hidden",
        backgroundColor: "#FFFDD9",
        marginTop: "10px",
        py: 1,
        marginBottom: "5px",
        // height: "40px", // Set a fixed height for the ticker
        display: "flex",
        alignItems: "center",
      }}
    >
      {renderContent()}
    </Box>
  );
};

export default TickerTape;
